import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const CheckCircleOutline: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99972 14.7324C11.7178 14.7324 14.7319 11.7183 14.7319 8.00021C14.7319 4.28215 11.7178 1.26807 7.99972 1.26807C4.28166 1.26807 1.26758 4.28215 1.26758 8.00021C1.26758 11.7183 4.28166 14.7324 7.99972 14.7324Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0209 5.66992L6.87807 10.8485L4.80664 9.29492"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
